import { getCurrentInstance } from '@vue/composition-api'

/**
 * Returns translated string if i18n package is available to Vue
 * If i18n is not configured then it will simply return what is being passed
 * Useful if you don't know if i18n is configured or not
 * Used in @core files to handle absence of i18n without errors
 * @param {String} key i18n key to use for translation
 */
export const t = key => {
  if (key == null || typeof key !== 'string') return key
  const vm = getCurrentInstance().proxy
  if (!vm.$t) return key
  // Nav titles are often plain English labels with no locale entry — skip
  // `$t()` when the key is missing to avoid vue-i18n dev console spam.
  if (vm.$te && !vm.$te(key)) return key
  const translated = vm.$t(key)
  return typeof translated === 'string' || typeof translated === 'number' ? translated : key
}

export const _ = null
